export enum IncludeOption {
  INCLUDE_NUMBER = 1,
  INCLUDE_CAPITAL_LETTER = 2,
  INCLUDE_SPECIAL = 4
}
